module.exports = __webpack_public_path__ + "static/media/back-button.ad1893a7.svg";